module.exports = __webpack_public_path__ + "h5/img/sales_empty.cebb2ff9.png";